<template>
  <v-layout row wrap my-2 v-if="links">
    <v-flex xs12 sm12>
      <v-carousel
        v-if="links.left"
        height="220px" 
        interval="15000" 
        style="box-shadow: none;" 
        class="carousel-links"
        :hide-controls="links.left.length < 2"
        :hide-delimiters="links.left.length < 2"
      >
        <v-carousel-item
          v-for="(item,i) in links.left"
          :key="i"
          :src="item.image_mobile ? item.image_mobile : item.image"
          @click="goToLink(item)"
          class="hover"
        ></v-carousel-item>
      </v-carousel>
    </v-flex>

    <v-flex xs12 sm12>
      <v-carousel 
        v-if="links.right"
        height="220px" 
        interval="18000" 
        style="box-shadow: none;" 
        class="carousel-links mt-2"
        :hide-controls="links.right.length < 2"
        :hide-delimiters="links.right.length < 2"
      >
        <v-carousel-item
          v-for="(item,i) in links.right"
          :key="i"
          :src="item.image_mobile ? item.image_mobile : item.image"
          @click="goToLink(item)"
          class="hover"
        ></v-carousel-item>
      </v-carousel>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  beforeMount() {
    if (!this.links.length) {
      let view_as = localStorage.getItem("view_as");
      this.fetchLinks(view_as);
    }
  },
  methods: {
    ...mapActions("links",["fetchLinks"]),
    goToLink(link) {
      if (link.is_blank == true) window.open(link.url, "_blank");
      else window.open(link.url, "_self");
    },
  },
  computed: {
    ...mapState("links", ["links"]),
  }
}
</script>

<style>
.carousel-links
  > div.v-carousel__controls
  > div
  > button.v-btn.v-btn--active.v-btn--icon.v-btn--small.theme--dark.v-carousel__controls__item {
  color: #638d37;
}

.carousel_links > div.v-carousel__controls > div > button > div > i {
  font-size: 10px !important;
}

.v-btn.v-btn--active.v-btn--icon.v-btn--small.theme--dark.v-carousel__controls__item:before > .v-btn__content > i{
  font-size: 10px !important;
}
</style>